import axios from 'axios';
import { API_URL } from '../config';

// Create an axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add request interceptor to include auth token if available
api.interceptors.request.use(config => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// API functions for governance
export const governanceAPI = {
  getProposals: async (status = 'all') => {
    try {
      const response = await api.get(`/governance/proposals?status=${status}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching proposals:', error);
      throw error;
    }
  },
  
  getProposalById: async (id) => {
    try {
      const response = await api.get(`/governance/proposals/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching proposal ${id}:`, error);
      throw error;
    }
  },
  
  submitProposal: async (proposalData) => {
    try {
      const response = await api.post('/governance/proposals', proposalData);
      return response.data;
    } catch (error) {
      console.error('Error submitting proposal:', error);
      throw error;
    }
  },
  
  voteOnProposal: async (proposalId, vote, wallet) => {
    try {
      const response = await api.post(`/governance/proposals/${proposalId}/vote`, {
        vote,
        wallet
      });
      return response.data;
    } catch (error) {
      console.error(`Error voting on proposal ${proposalId}:`, error);
      throw error;
    }
  }
};

// API functions for portfolio/trades
export const portfolioAPI = {
  getPortfolio: async () => {
    try {
      const response = await api.get('/portfolio');
      return response.data;
    } catch (error) {
      console.error('Error fetching portfolio data:', error);
      throw error;
    }
  },
  
  getTradeHistory: async () => {
    try {
      const response = await api.get('/portfolio/history');
      return response.data;
    } catch (error) {
      console.error('Error fetching trade history:', error);
      throw error;
    }
  }
};

// API functions for AI recommendations
export const aiAPI = {
  getTrending: async () => {
    try {
      const response = await api.get('/ai/trending');
      return response.data;
    } catch (error) {
      console.error('Error fetching AI trending tokens:', error);
      throw error;
    }
  },
  
  analyzeToken: async (symbol) => {
    try {
      const response = await api.get(`/ai/analyze/${symbol}`);
      return response.data;
    } catch (error) {
      console.error(`Error analyzing token ${symbol}:`, error);
      throw error;
    }
  },
  
  proposeAITrade: async (tradeData) => {
    try {
      const response = await api.post('/ai/propose', tradeData);
      return response.data;
    } catch (error) {
      console.error('Error proposing AI trade:', error);
      throw error;
    }
  }
};

// API functions for wallet/rewards
export const walletAPI = {
  getWalletData: async (address) => {
    try {
      const response = await api.get(`/wallet/${address}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching wallet data for ${address}:`, error);
      throw error;
    }
  },
  
  getWalletActivity: async (address) => {
    try {
      const response = await api.get(`/wallet/${address}/activity`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching wallet activity for ${address}:`, error);
      throw error;
    }
  },
  
  getRewards: async (address) => {
    try {
      const response = await api.get(`/wallet/${address}/rewards`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching rewards for ${address}:`, error);
      throw error;
    }
  },
  
  claimReward: async (rewardId) => {
    try {
      const response = await api.post(`/wallet/rewards/${rewardId}/claim`);
      return response.data;
    } catch (error) {
      console.error(`Error claiming reward ${rewardId}:`, error);
      throw error;
    }
  }
};

export default {
  governanceAPI,
  portfolioAPI,
  aiAPI,
  walletAPI
};